<template>
  <div class="">
    <el-header style="padding: 0px;display:flex;justify-content:flex-end;align-items: center">
      <el-input v-model="filterParams.projectName" placeholder="输入项目名称搜索"  style="width:300px;" clearable=""/>
      <el-button v-waves class="filter-item" type="primary" size="mini" icon="el-icon-search" style="margin-left: -5px;z-index:1" @click="searchProduct()">搜索</el-button>
      <div style="margin-left: 10px;display: inline">
        <el-button
          type="primary"
          size="mini"
          @click="handleAdd">
          新增
        </el-button>
      </div>
      <div style="margin-left: 10px;display: inline">
        <el-button
          :disabled="operDisabled"
          type="success"
          size="mini"
          @click="batchUpdate('1')">
          启用
        </el-button>
      </div>
      <div style="margin-left: 10px;display: inline">
        <el-button
          :disabled="operDisabled"
          type="danger"
          size="mini"
          @click="batchUpdate('0')">
          禁用
        </el-button>
      </div>
    </el-header>
    <iTable
      :data="dataList"
      :col-configs="colConfigs"
      :default-sort="{prop: 'age', order: 'descending'}"
      :row-class-name="tableRowClassName"
      :row-click="clickRowEvent"
      :max-height="maxHeight"
      :select="selectCheck"
      :show-loading="isLoading"
      :table-key="tableKey"
      :selection-change="handleSelectionChange"
      :filter-change="handleFilterChange"
      :sort-change="handleSortChange"
      itable-loading="loading"
      row-key="id"
    >
      <el-table-column slot="selection" align="center" type="selection" width="50" fixed="left"/>
      <el-table-column slot="index" :formatter="formatterIndex" label="序号" align="center" width="50" fixed="left"/>
      <el-table-column slot="operate" label="操作" width="180" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click.stop="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="text" v-if="scope.row.projectAdminId===null||scope.row.projectAdminId===''" size="small" @click.stop="handleCusAdminAdd(scope.$index, scope.row)">新增管理员</el-button>
          <el-button type="text" v-else size="small" @click.stop="handleCusAdminEdit(scope.$index, scope.row)">编辑管理员</el-button>
        </template>
      </el-table-column>
    </iTable>
    <el-pagination
      :current-page="page.currentPage"
      :page-sizes="page.pageSizes"
      :total="page.total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"/>
    <!--弹出内容-->
    <add v-if="showAddVisible" ref="add" @refresh="initData"/>
    <!--弹出内容-->
    <add-admin v-if="showAddAdminVisible" ref="addAdmin" @refresh="initData"/>
  </div>
</template>
<script>
  /* eslint-disable handle-callback-err */
  import waves from '@/directive/waves' // Waves directive
  import iTable from '@/components/table/index'
  import add from './add'
  import addAdmin from './addAdmin'
  import { getProjectListpage,updateListpage,addListpage,batchUpdateStatus } from  "@/api/project/index"
  export default {
    components: { iTable, add, addAdmin },
    directives: { waves },
    data() {
      return {
        showAddVisible: false,
        showAddAdminVisible: false,
        operDisabled: true,
        selection: [], // 选中的数据
        maxHeight: null,
        clientHeight: null,
        dataList: [],
        page: {
          pageSizes: [10,20,30,50],
          total: 0,
          currentPage: 1,
          currentPages: 0,
          pageSize: 10
        },
        isLoading: true,
        dialogVisible: false,
        showFooter: false, // 是否显示弹框的底部按钮
        fixFooter: true, // 是否固定显示组件内的footer按钮
        beginDateScope: '',
        faangledoubleup: 'fa-angle-double-up',
        faangledoubledown: 'fa-angle-double-down',
        filterParams: {
          projectName: '',
          status: '',
        },
        tableKey: 'table1' // 区分唯一性  solt渲染时需要对应的key
      }
    },
    computed: {
      // 注意！！！colConfigs不能放在data 里面，因为当语言切换的时候 他是不会变的 ，要写在computed内
      colConfigs() {
        return [
          { slot: 'selection' }, // 复选框列
          { slot: 'index' }, // 序号列
          { prop: 'projectName', label: '项目名称', align: 'center',width:'150' },
          { prop: 'cityName', label: '所在地', align: 'center' },
          { prop: 'projectHead', label: '项目负责人', align: 'center',width:'100' },
          { prop: 'projectPhone', label: '联系电话', align: 'center',width:'100' },
          { prop: 'projectEmail', label: '联系邮箱', align: 'center',width:'100' },
          { prop: 'statusTxt', label: '状态', align: 'center' },
          { prop: 'createTime', label: '创建时间', align: 'center', width:'150' },
          { slot: 'operate' } // 操作
        ]
      }
    },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function() {
        this.changeFixed(this.clientHeight)
      }
    },
    mounted() {
      this.initData()
    },
    methods: {
      initData() {
        const that = this
        // 获取浏览器可视区域高度
        that.$set(that, 'clientHeight', `${document.documentElement.clientHeight}`)
        window.onresize = function temp() {
          that.$set(that, 'clientHeight', `${document.documentElement.clientHeight}`)
        }
        that.loadProduct()
      },
      searchProduct() {
        this.page.currentPage = 1
        this.loadProduct()
      },
      // 给行加行号
      tableRowClassName({ row, rowIndex }) {
        // 把每一行的索引放进row
        row.index = rowIndex
      },
      formatterIndex(row, column, cellValue, index) {
        // 放回索引值
        return this.page.currentPages * (this.page.pageSize - 1) + 1 + row.index
      },
      // 点击行事件
      clickRowEvent(row, column, event) {
        console.log(row)
        console.log(column)
        console.log(event)
      },

      // 选中复选框事件
      selectCheck(selection, row) {
        // 你可以这样修改行数据值
        // selection[0].id = '123'
        console.log(selection)
        console.log(row)
      },
      handleSelectionChange(val) {
        this.selection = val
        if (val.length > 0) {
          this.operDisabled = false
        } else {
          this.operDisabled = true
        }
      },
      // 批量发布/禁用
      batchUpdate: function(status) {
        const val = this.selection
        let ids = ''
        for (let i = 0; i < val.length; i++) {
          if (val[i].status !== status) {
            ids += val[i].id + ','
          }
        }
        if (ids) {
          ids = ids.substring(0, ids.lastIndexOf(','))
          const that = this
          let title = '确定要禁用选中项目吗？'
          let title1 = '禁用成功'
          if (status === '1') {
            title = '确定要启用选中项目吗？'
            title1 = '启用成功'
          }
          this.$confirm(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            batchUpdateStatus({ id: ids, status: status }).then((res) => {
                that.$message.success(title1)
                that.loadProduct()
            })
          })
        } else {
          let title1 = '请选择已启用的项目'
          if (status === '1') {
            title1 = '请选择未启用的项目'
          }
          this.$message({
            message: title1,
            type: 'info'
          })
        }
      },
      // 表格最大高自适应
      changeFixed(clientHeight) {
        // 导航栏高65+边距上下30*2+ el-table 链接高40 + 分页高32 = 183
        this.$set(this, 'maxHeight', clientHeight - 197)
      },
      // 页码变化时
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
        // 切换成每页20条的数据
        this.page.pageSize = val
        this.isLoading=true
        this.loadProduct()
      },
      // 当前页变化时
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`)
        // 获取table数据
        this.page.currentPage = val
        this.isLoading=true
        this.loadProduct()
      },
      loadProduct() {
        let params = this.filterParams;
        params.page= this.page.currentPage;
        params.limit = this.page.pageSize;
        getProjectListpage(params).then(res => {
          this.page.total = res.data.total
          this.dataList = res.data.records
          this.isLoading = false
        })
      },
      // 当talbel中任何一列的过滤条件点击确定和覆盖时，都会触发此事件。
      handleFilterChange(filters) {
        // 拷贝filters的值。
        for (const i in filters) {
          const row = i // 保存 column-key的值，如果事先没有为column-key赋值，系统会自动生成一个唯一且恒定的名称
          const val = filters[i]
          if (val != null && val.length > 0) {
            this.$set(this.filterParams, row, val[0])
          } else {
            this.$set(this.filterParams, row, '')
          }
        }
        this.currentPage = 1
        this.loadProduct()
      },
      // 新增
      handleAdd() {
        this.showAddVisible = true
        this.$nextTick(() => {
          this.$refs.add.init('')
        })
      },
      // 详情
      handleEdit(index, row) {
        this.showAddVisible = true
        this.$nextTick(() => {
          this.$refs.add.init(row.id)
        })
      },
      // 新增管理员
      handleCusAdminAdd(index, row) {
        this.showAddAdminVisible = true
        this.$nextTick(() => {
          this.$refs.addAdmin.init(row.id,row.projectAdminId)
        })
      },
      // 编辑管理员
      handleCusAdminEdit(index, row) {
        this.showAddAdminVisible = true
        this.$nextTick(() => {
          this.$refs.addAdmin.init(row.id,row.projectAdminId)
        })
      }
    }
  }
</script>
<style scoped>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-input--mini .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
</style>
